// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/font/nasalization-rg.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nasalization";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

:root {
  --yellow: #febc08;
  --DYello: #fcbb0b;
  --rating: #ffe104;
  --btnYellow: #ffbb0a;
  --pink: #ff75b3;
  --dPink: #e20f6f;
  --LPink: #ff289c;
  --blue: #7380ff;
  --dBlue: #264ec8;
  --Unigray: #112f48;
  --LGrey: #c7c7c7;
  --green: #a5cc48;
  --pSize: 14px;
  --bHsize: 60px;
  --mbHsize: 26px;
  --hSize: 40px;
  --mhSize: 20px;
  --sHsize: 25px;
  --f20: 20px;
  --f15: 14px;
  --f45: 45px;
  --f600: 600;
  --f700: 700;
}
body {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;
  overflow-x: hidden;
}

img {
  -webkit-user-select: none;
          user-select: none;
}

h1 {
  color: red;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
a,
span {
  font-family: "Poppins";
}

li {
  font-size: 14px;
  font-size: var(--pSize);
}

a {
  text-decoration: none !important;
  cursor: pointer;
}

img {
  width: 100%;
}

.pt-100 {
  padding-top: 100px;
}

.pt-50 {
  padding-top: 50px;
}

.pt-30 {
  padding-top: 30px;
}

.pt-10 {
  padding-top: 10px;
}

.pt-20 {
  padding-top: 20px;
}

.pb-20 {
  padding-bottom: 20px;
}

.pb-30 {
  padding-bottom: 30px;
}

.pb-50 {
  padding-bottom: 50px;
}

.pb-100 {
  padding-bottom: 100px;
}

.mtb-20 {
  margin: 20px 0px;
}

.mb-50 {
  margin-bottom: 50px;
}

.mb-100 {
  margin-bottom: 100px;
}

.mbc-5 {
  margin-bottom: 5px;
}

.ff {
  font-family: "Poppins";
}

.fw-400 {
  font-weight: 400;
}

.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.fw-700 {
  font-weight: 700;
}

.fw-800 {
  font-weight: 700;
}

.pSize {
  font-size: 14px;
  font-size: var(--pSize);
}

.f-20 {
  font-size: 20px;
  font-size: var(--f20);
}

.f-15 {
  font-size: 15px;
}

.f-18 {
  font-size: 18px;
}

.dBlue {
  color: #264ec8;
  color: var(--dBlue);
}

.dPink {
  color: #e20f6f;
  color: var(--dPink);
}

.pink-c {
  color: #ff75b3;
  color: var(--pink);
}

.violet-c {
  color: #6e5ac8;
}

.green-c {
  color: #a6cb46;
}

.ratingC {
  color: #ffe104;
  color: var(--rating);
}

.hSize {
  font-size: 40px;
  font-size: var(--hSize);
}

.w-fitC {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.Unigray {
  color: #112f48;
  color: var(--Unigray);
}

.inh2 {
  font-weight: 700;
  font-size: 45px;
  font-size: var(--f45);
  color: #264ec8;
  color: var(--dBlue);
  text-transform: uppercase;
  text-align: left;
}

.subHeading {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #264ec8;
  color: var(--dBlue);
}

.subHeading span {
  color: #e20f6f;
  color: var(--dPink);
}

.inh2 span {
  color: #e20f6f;
  color: var(--dPink);
}

.inb {
  font-size: 30px;
  font-weight: 700;
  color: #264ec8;
  color: var(--dBlue);
  text-align: left;
  line-height: 1.4;
}

.inb span {
  color: #e20f6f;
  color: var(--dPink);
}

.btndefault {
  background: #264ec8;
  background: var(--dBlue);
  color: #fff;
  padding: 10px 30px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 25px;
}

.mt-50 {
  margin-top: 50px;
}

input:focus,
button:focus,
select:focus,
textarea:focus {
  outline: none !important;
  box-shadow: none !important;
}

.error-text {
  color: #ff0000;
}
.common-btn {
  background: #264ec8;
  border-radius: 40px;
  color: #fff;
}
.uniBtn {
  border-radius: 30px;
  cursor: pointer;
  padding: 15px 40px;
  font-size: 14px;
  font-size: var(--pSize);
  font-weight: 700;
  line-height: 2.2;
  text-transform: capitalize;
  display: inline-block;
}

.uniBtnBlueBorder {
  border: 2px solid #264ec8;
  border: 2px solid var(--dBlue);
  color: #e20f6f;
  color: var(--dPink);
  background: #ffffff;
}

.uniBtnPinkBorder {
  border: 2px solid #e20f6f;
  border: 2px solid var(--dPink);
  color: #264ec8;
  color: var(--dBlue);
  background: #ffffff;
}

.uniBtnPurpleBorder {
  border: 2px solid #7380ff;
  border: 2px solid var(--blue);
  color: #264ec8;
  color: var(--dBlue);
  background: #ffffff;
}

.uniBtnBlue {
  border: #264ec8;
  border: var(--dBlue);
  color: #ffffff;
  background: #264ec8;
  background: var(--dBlue);
}
.uniBtnBlue:hover {
  background-color: #e20f6f;
  background-color: var(--dPink);
  color: #ffffff;
}
.uniBtnPink {
  border: #e20f6f;
  border: var(--dPink);
  color: #ffffff;
  background: #e20f6f;
  background: var(--dPink);
}
.btnPHeavy {
  padding: 15px 40px;
}
.btnPLight {
  padding: 6px 25px;
}
/* display none */

#AboutUsPage .uniBtn,
#LifeAtPage .uniBtn {
  display: none;
}
#AboutUsPage .home_form_btn {
  display: block;
}

.login-popup .modal-content {
  width: 100%;
}

.delete-icon {
  cursor: pointer;
}

/* heading style for new pages */
.heading-npgs h2 {
  font-weight: 700;
  text-align: center;
}

.dark-pink-head h2 {
  color: #e20f6f;
  color: var(--dPink);
}

.dark-blue-head h2 {
  color: #264ec8;
  color: var(--dBlue);
}

.sub-heading-npgs {
  text-align: center;
}

.sub-heading-npgs p {
  color: #112f48;
  color: var(--Unigray);
}

.dark-blue-head p {
  color: #264ec8;
  color: var(--dBlue);
  font-size: 25px;
  margin-bottom: 0px;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #fff !important;
  border: 1px solid #0ab7fd !important;
}

@media (max-width: 576px) {
  :root {
    --bHsize: 26px !important;
    --hSize: 26px !important;
    --f45: 26px !important;
    --f20: 16px !important;
  }
  .inb {
    font-size: 22px;
  }
  .pt-100 {
    padding-top: 50px !important;
  }
  .pb-100 {
    padding-bottom: 50px !important;
  }
  .btnPLight {
    padding: 5px 15px;
  }
  .subHeading {
    font-size: 16px;
  }
  .uniBtn {
    padding: 0px 12px;
  }

  .pt-mob-20 {
    padding-top: 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  :root {
    --f45: 28px !important;
    --f20: 16px;
    --hSize: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAIA;EACE,2BAA2B;EAC3B,4CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;EACd,cAAc;EACd,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;AACA;;;;;;;;;EASE,sBAAsB;AACxB;;AAEA;EACE,eAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,eAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,eAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,0BAAkB;EAAlB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAqB;EAArB,qBAAqB;EACrB,cAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAwB;EAAxB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAA8B;EAA9B,8BAA8B;EAC9B,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAA8B;EAA9B,8BAA8B;EAC9B,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAA6B;EAA7B,6BAA6B;EAC7B,cAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAoB;EAApB,oBAAoB;EACpB,cAAc;EACd,mBAAwB;EAAxB,wBAAwB;AAC1B;AACA;EACE,yBAA8B;EAA9B,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,eAAoB;EAApB,oBAAoB;EACpB,cAAc;EACd,mBAAwB;EAAxB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA,iBAAiB;;AAEjB;;EAEE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,cAAmB;EAAnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,+BAA+B;EACjC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Poppins:wght@300;400;500;600;700;800;900&display=swap\");\n\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap\");\n\n@font-face {\n  font-family: \"Nasalization\";\n  src: url(\"../public/font/nasalization-rg.otf\");\n}\n\n:root {\n  --yellow: #febc08;\n  --DYello: #fcbb0b;\n  --rating: #ffe104;\n  --btnYellow: #ffbb0a;\n  --pink: #ff75b3;\n  --dPink: #e20f6f;\n  --LPink: #ff289c;\n  --blue: #7380ff;\n  --dBlue: #264ec8;\n  --Unigray: #112f48;\n  --LGrey: #c7c7c7;\n  --green: #a5cc48;\n  --pSize: 14px;\n  --bHsize: 60px;\n  --mbHsize: 26px;\n  --hSize: 40px;\n  --mhSize: 20px;\n  --sHsize: 25px;\n  --f20: 20px;\n  --f15: 14px;\n  --f45: 45px;\n  --f600: 600;\n  --f700: 700;\n}\nbody {\n  padding: 0px;\n  margin: 0px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\nimg {\n  user-select: none;\n}\n\nh1 {\n  color: red;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\na,\nspan {\n  font-family: \"Poppins\";\n}\n\nli {\n  font-size: var(--pSize);\n}\n\na {\n  text-decoration: none !important;\n  cursor: pointer;\n}\n\nimg {\n  width: 100%;\n}\n\n.pt-100 {\n  padding-top: 100px;\n}\n\n.pt-50 {\n  padding-top: 50px;\n}\n\n.pt-30 {\n  padding-top: 30px;\n}\n\n.pt-10 {\n  padding-top: 10px;\n}\n\n.pt-20 {\n  padding-top: 20px;\n}\n\n.pb-20 {\n  padding-bottom: 20px;\n}\n\n.pb-30 {\n  padding-bottom: 30px;\n}\n\n.pb-50 {\n  padding-bottom: 50px;\n}\n\n.pb-100 {\n  padding-bottom: 100px;\n}\n\n.mtb-20 {\n  margin: 20px 0px;\n}\n\n.mb-50 {\n  margin-bottom: 50px;\n}\n\n.mb-100 {\n  margin-bottom: 100px;\n}\n\n.mbc-5 {\n  margin-bottom: 5px;\n}\n\n.ff {\n  font-family: \"Poppins\";\n}\n\n.fw-400 {\n  font-weight: 400;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.fw-700 {\n  font-weight: 700;\n}\n\n.fw-800 {\n  font-weight: 700;\n}\n\n.pSize {\n  font-size: var(--pSize);\n}\n\n.f-20 {\n  font-size: var(--f20);\n}\n\n.f-15 {\n  font-size: 15px;\n}\n\n.f-18 {\n  font-size: 18px;\n}\n\n.dBlue {\n  color: var(--dBlue);\n}\n\n.dPink {\n  color: var(--dPink);\n}\n\n.pink-c {\n  color: var(--pink);\n}\n\n.violet-c {\n  color: #6e5ac8;\n}\n\n.green-c {\n  color: #a6cb46;\n}\n\n.ratingC {\n  color: var(--rating);\n}\n\n.hSize {\n  font-size: var(--hSize);\n}\n\n.w-fitC {\n  width: fit-content;\n}\n\n.Unigray {\n  color: var(--Unigray);\n}\n\n.inh2 {\n  font-weight: 700;\n  font-size: var(--f45);\n  color: var(--dBlue);\n  text-transform: uppercase;\n  text-align: left;\n}\n\n.subHeading {\n  font-size: 22px;\n  font-weight: 600;\n  text-align: center;\n  color: var(--dBlue);\n}\n\n.subHeading span {\n  color: var(--dPink);\n}\n\n.inh2 span {\n  color: var(--dPink);\n}\n\n.inb {\n  font-size: 30px;\n  font-weight: 700;\n  color: var(--dBlue);\n  text-align: left;\n  line-height: 1.4;\n}\n\n.inb span {\n  color: var(--dPink);\n}\n\n.btndefault {\n  background: var(--dBlue);\n  color: #fff;\n  padding: 10px 30px;\n  font-size: 18px;\n  font-weight: 700;\n  border-radius: 25px;\n}\n\n.mt-50 {\n  margin-top: 50px;\n}\n\ninput:focus,\nbutton:focus,\nselect:focus,\ntextarea:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.error-text {\n  color: #ff0000;\n}\n.common-btn {\n  background: #264ec8;\n  border-radius: 40px;\n  color: #fff;\n}\n.uniBtn {\n  border-radius: 30px;\n  cursor: pointer;\n  padding: 15px 40px;\n  font-size: var(--pSize);\n  font-weight: 700;\n  line-height: 2.2;\n  text-transform: capitalize;\n  display: inline-block;\n}\n\n.uniBtnBlueBorder {\n  border: 2px solid var(--dBlue);\n  color: var(--dPink);\n  background: #ffffff;\n}\n\n.uniBtnPinkBorder {\n  border: 2px solid var(--dPink);\n  color: var(--dBlue);\n  background: #ffffff;\n}\n\n.uniBtnPurpleBorder {\n  border: 2px solid var(--blue);\n  color: var(--dBlue);\n  background: #ffffff;\n}\n\n.uniBtnBlue {\n  border: var(--dBlue);\n  color: #ffffff;\n  background: var(--dBlue);\n}\n.uniBtnBlue:hover {\n  background-color: var(--dPink);\n  color: #ffffff;\n}\n.uniBtnPink {\n  border: var(--dPink);\n  color: #ffffff;\n  background: var(--dPink);\n}\n.btnPHeavy {\n  padding: 15px 40px;\n}\n.btnPLight {\n  padding: 6px 25px;\n}\n/* display none */\n\n#AboutUsPage .uniBtn,\n#LifeAtPage .uniBtn {\n  display: none;\n}\n#AboutUsPage .home_form_btn {\n  display: block;\n}\n\n.login-popup .modal-content {\n  width: 100%;\n}\n\n.delete-icon {\n  cursor: pointer;\n}\n\n/* heading style for new pages */\n.heading-npgs h2 {\n  font-weight: 700;\n  text-align: center;\n}\n\n.dark-pink-head h2 {\n  color: var(--dPink);\n}\n\n.dark-blue-head h2 {\n  color: var(--dBlue);\n}\n\n.sub-heading-npgs {\n  text-align: center;\n}\n\n.sub-heading-npgs p {\n  color: var(--Unigray);\n}\n\n.dark-blue-head p {\n  color: var(--dBlue);\n  font-size: 25px;\n  margin-bottom: 0px;\n}\n\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n  background: #fff !important;\n  border: 1px solid #0ab7fd !important;\n}\n\n@media (max-width: 576px) {\n  :root {\n    --bHsize: 26px !important;\n    --hSize: 26px !important;\n    --f45: 26px !important;\n    --f20: 16px !important;\n  }\n  .inb {\n    font-size: 22px;\n  }\n  .pt-100 {\n    padding-top: 50px !important;\n  }\n  .pb-100 {\n    padding-bottom: 50px !important;\n  }\n  .btnPLight {\n    padding: 5px 15px;\n  }\n  .subHeading {\n    font-size: 16px;\n  }\n  .uniBtn {\n    padding: 0px 12px;\n  }\n\n  .pt-mob-20 {\n    padding-top: 20px;\n  }\n}\n@media only screen and (min-width: 576px) and (max-width: 992px) {\n  :root {\n    --f45: 28px !important;\n    --f20: 16px;\n    --hSize: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
